import { SurveyModel } from 'survey-core';
import {
  ALL_TOOLBOX_ITEMS,
  PROPERTY_TYPES,
  SURVEY_PROPERTIES_MAP,
} from './surveyOwnContants';

// GROUP 1 TOOLBOX properties
export const TOOLBOX_ITEMS_TO_REMOVE = {
  INPUT: [
    ALL_TOOLBOX_ITEMS.EXPRESSION,
    ALL_TOOLBOX_ITEMS.SIGNATURE_PAD,
    ALL_TOOLBOX_ITEMS.SPARK_OUTPUT,
  ],
  OUTPUT: [
    ALL_TOOLBOX_ITEMS.RADIO_GROUP,
    ALL_TOOLBOX_ITEMS.RATING,
    ALL_TOOLBOX_ITEMS.CHECKBOX,
    ALL_TOOLBOX_ITEMS.DROPDOWN,
    ALL_TOOLBOX_ITEMS.TAG_BOX,
    ALL_TOOLBOX_ITEMS.BOOLEAN,
    ALL_TOOLBOX_ITEMS.FILE,
    ALL_TOOLBOX_ITEMS.IMAGE_PICKER,
    ALL_TOOLBOX_ITEMS.RANKING,
    ALL_TOOLBOX_ITEMS.TEXT,
    ALL_TOOLBOX_ITEMS.COMMENT,
    ALL_TOOLBOX_ITEMS.MULTIPLE_TEXT,
    ALL_TOOLBOX_ITEMS.MATRIX,
    ALL_TOOLBOX_ITEMS.MATRIX_DROPDOWN,
    ALL_TOOLBOX_ITEMS.MATRIX_DYNAMIC,
    ALL_TOOLBOX_ITEMS.EXPRESSION,
    ALL_TOOLBOX_ITEMS.SIGNATURE_PAD,
    ALL_TOOLBOX_ITEMS.PANEL_DYNAMIC,
  ],
};

// GROUP 2 survey properties
export const SURVEY_GRID_PROPERTIES = {
  PAGES: [
    SURVEY_PROPERTIES_MAP.PAGES,
    SURVEY_PROPERTIES_MAP.SHOW_PAGE_TITLES,
    SURVEY_PROPERTIES_MAP.SHOW_PAGE_NUMBERS,
  ],
  VALIDATION: ['focusOnFirstError', 'checkErrorsMode'],
};

export const INCLUDED_SURVEY_PROPERTIES = [
  ...SURVEY_GRID_PROPERTIES.PAGES,
  ...SURVEY_GRID_PROPERTIES.VALIDATION,
];

// GROUP 3 Page properties
export const PAGE_PROPERTIES = {
  GENERAL: [
    // 'name',
    'title',
    'description',
  ],
};

export const INCLUDED_PAGE_PROPERTIES = [...PAGE_PROPERTIES.GENERAL];

// GROUP 4 Input properties
export const COMMON_INPUT_PROPERTIES = {
  GENERAL: [
    // 'name',
    'title',
    'description',
    'isRequired',
    'showCommentArea',
    'placeholder',
    'autocomplete',
    'inputType',
    'imageLink',
    'contentMode',
    'imageFit',
    'imageHeight',
    'imageWidth',
    'altText',
  ],
  VALIDATION: [
    'validators',
    'requiredErrorText',
    'otherErrorText',
    'eachRowUnique',
    'isAllRowRequired',
  ],
  LAYOUT: ['startWithNewLine'],
  INPUT_MASK_SETTING: ['maskType', 'maskSettings'],
  CHOICES: [
    'choices',
    'choicesFromQuestion',
    'choicesFromQuestionMode',
    'choiceValuesFromQuestion',
    'choiceTextsFromQuestion',
    'choicesOrder',
    'minSelectedChoices',
    'maxSelectedChoices',
    'showSelectAllItem',
    'selectAllText',
    'showOtherItem',
    'otherText',
    'otherPlaceholder',
    'showNoneItem',
    'noneText',
    'refuseText',
    'dontKnowText',
    'showClearButton',
    'separateSpecialChoices',
  ],
  CHOICES_FROM_WEB_SERVICE: [
    'choicesByUrl',
    'url',
    'path',
    'valueName',
    'titleName',
    'allowEmptyResponse',
  ],
  COLUMNS: ['columns'],
  ROWS: ['rows', 'rowsOrder', 'hideIfRowsEmpty'],
};

export const INPUT_PROPERTIES = {
  RADIO_GROUP: [
    'commentText',
    'commentPlaceholder',
    // custom property testValue
    'testValue',
    'defaultValue',
    ...COMMON_INPUT_PROPERTIES.GENERAL,
    ...COMMON_INPUT_PROPERTIES.CHOICES,
    ...COMMON_INPUT_PROPERTIES.CHOICES_FROM_WEB_SERVICE,
    ...COMMON_INPUT_PROPERTIES.LAYOUT,
    ...COMMON_INPUT_PROPERTIES.VALIDATION,
  ],
  CHECKBOX: [
    'commentText',
    'commentPlaceholder',
    // custom property testValue
    'testValue',
    'defaultValue',
    ...COMMON_INPUT_PROPERTIES.GENERAL,
    ...COMMON_INPUT_PROPERTIES.CHOICES,
    ...COMMON_INPUT_PROPERTIES.CHOICES_FROM_WEB_SERVICE,
    ...COMMON_INPUT_PROPERTIES.LAYOUT,
    ...COMMON_INPUT_PROPERTIES.VALIDATION,
  ],

  RATTING: [
    'displayMode',
    'rateType',
    'rateCount',
    'rateMax',
    'autoGenerate',
    'rateValues',
    'minRateDescription',
    'maxRateDescription',
    'rateDescriptionLocation',
    // custom property testValue
    'testValue',
    'defaultValue',
    ...COMMON_INPUT_PROPERTIES.GENERAL,
    ...COMMON_INPUT_PROPERTIES.LAYOUT,
    ...COMMON_INPUT_PROPERTIES.VALIDATION,
  ],
  DROPDOWN: [
    // custom property testValue
    'testValue',
    'defaultValue',
    ...COMMON_INPUT_PROPERTIES.GENERAL,
    ...COMMON_INPUT_PROPERTIES.CHOICES,
    ...COMMON_INPUT_PROPERTIES.CHOICES_FROM_WEB_SERVICE,
    ...COMMON_INPUT_PROPERTIES.LAYOUT,
    ...COMMON_INPUT_PROPERTIES.VALIDATION,
  ],
  MULTI_SELECT_DROP_DOWN: [
    // custom property testValue
    'testValue',
    'defaultValue',
    ...COMMON_INPUT_PROPERTIES.GENERAL,
    ...COMMON_INPUT_PROPERTIES.CHOICES,
    ...COMMON_INPUT_PROPERTIES.CHOICES_FROM_WEB_SERVICE,
    ...COMMON_INPUT_PROPERTIES.LAYOUT,
    ...COMMON_INPUT_PROPERTIES.VALIDATION,
  ],
  YES_NO_BOOLEAN: [
    // custom property testValue
    'testValue',
    'defaultValue',
    ...COMMON_INPUT_PROPERTIES.GENERAL,
    ...COMMON_INPUT_PROPERTIES.CHOICES,
    ...COMMON_INPUT_PROPERTIES.CHOICES_FROM_WEB_SERVICE,
    ...COMMON_INPUT_PROPERTIES.LAYOUT,
    ...COMMON_INPUT_PROPERTIES.VALIDATION,
  ],
  FILE_UPLOAD: [
    // custom property testValue
    'testValue',
    'defaultValue',
    ...COMMON_INPUT_PROPERTIES.GENERAL,
    ...COMMON_INPUT_PROPERTIES.CHOICES,
    ...COMMON_INPUT_PROPERTIES.CHOICES_FROM_WEB_SERVICE,
    ...COMMON_INPUT_PROPERTIES.LAYOUT,
    ...COMMON_INPUT_PROPERTIES.VALIDATION,
  ],
  IMAGE_PICKER: [
    // custom property testValue
    'testValue',
    'defaultValue',
    ...COMMON_INPUT_PROPERTIES.GENERAL,
    ...COMMON_INPUT_PROPERTIES.CHOICES,
    ...COMMON_INPUT_PROPERTIES.CHOICES_FROM_WEB_SERVICE,
    ...COMMON_INPUT_PROPERTIES.LAYOUT,
    ...COMMON_INPUT_PROPERTIES.VALIDATION,
  ],
  RANKING: [
    // custom property testValue
    'testValue',
    'defaultValue',
    ...COMMON_INPUT_PROPERTIES.GENERAL,
    ...COMMON_INPUT_PROPERTIES.LAYOUT,
    ...COMMON_INPUT_PROPERTIES.CHOICES,
    ...COMMON_INPUT_PROPERTIES.CHOICES_FROM_WEB_SERVICE,
    ...COMMON_INPUT_PROPERTIES.VALIDATION,
  ],
  SINGLE_LINE_TEXT: [
    // custom property testValue
    'testValue',
    'defaultValue',
    ...COMMON_INPUT_PROPERTIES.GENERAL,
    ...COMMON_INPUT_PROPERTIES.LAYOUT,
    ...COMMON_INPUT_PROPERTIES.VALIDATION,
    ...COMMON_INPUT_PROPERTIES.INPUT_MASK_SETTING,
  ],
  LONG_TEXT: [
    // custom property testValue
    'testValue',
    'defaultValue',
    ...COMMON_INPUT_PROPERTIES.GENERAL,
    ...COMMON_INPUT_PROPERTIES.LAYOUT,
    ...COMMON_INPUT_PROPERTIES.VALIDATION,
  ],
  MULTIPLE_TEXT_BOX: [
    'items',
    // custom property testValue
    'testValue',
    'defaultValue',
    ...COMMON_INPUT_PROPERTIES.GENERAL,
    ...COMMON_INPUT_PROPERTIES.LAYOUT,
    ...COMMON_INPUT_PROPERTIES.VALIDATION,
  ],
  PANEL: [
    'LONG_TEXT showNumber',
    'showQuestionNumbers',
    'questionStartIndex',
    // custom property testValue
    'testValue',
    'defaultValue',
    ...COMMON_INPUT_PROPERTIES.GENERAL,
    ...COMMON_INPUT_PROPERTIES.LAYOUT,
    ...COMMON_INPUT_PROPERTIES.VALIDATION,
  ],
  PANEL_DYNAMIC: [
    'LONG_TEXT showNumber',
    'showQuestionNumbers',
    'questionStartIndex',
    // custom property testValue
    'testValue',
    'defaultValue',
    ...COMMON_INPUT_PROPERTIES.GENERAL,
    ...COMMON_INPUT_PROPERTIES.LAYOUT,
    ...COMMON_INPUT_PROPERTIES.VALIDATION,
  ],
  SINGLE_SELECT_MATRIX: [
    'cells',
    // custom property testValue
    'testValue',
    'defaultValue',
    ...COMMON_INPUT_PROPERTIES.GENERAL,
    ...COMMON_INPUT_PROPERTIES.LAYOUT,
    ...COMMON_INPUT_PROPERTIES.VALIDATION,
    ...COMMON_INPUT_PROPERTIES.COLUMNS,
    ...COMMON_INPUT_PROPERTIES.ROWS,
  ],
  MULTI_SELECT_MATRIX: [
    // custom property testValue
    'testValue',
    'defaultValue',
    ...COMMON_INPUT_PROPERTIES.GENERAL,
    ...COMMON_INPUT_PROPERTIES.LAYOUT,
    ...COMMON_INPUT_PROPERTIES.VALIDATION,
    ...COMMON_INPUT_PROPERTIES.COLUMNS,
    ...COMMON_INPUT_PROPERTIES.ROWS,
  ],
  DYNAMIC_MATRIX: [
    // custom property testValue
    'testValue',
    'defaultValue',
    ...COMMON_INPUT_PROPERTIES.GENERAL,
    ...COMMON_INPUT_PROPERTIES.LAYOUT,
    ...COMMON_INPUT_PROPERTIES.VALIDATION,
    ...COMMON_INPUT_PROPERTIES.COLUMNS,
  ],
  HTML: [
    // custom property testValue
    'html',
    'testValue',
    'defaultValue',
    ...COMMON_INPUT_PROPERTIES.GENERAL,
    ...COMMON_INPUT_PROPERTIES.LAYOUT,
  ],
  IMAGE: [
    // custom property testValue

    'testValue',
    'defaultValue',
    'html',
    ...COMMON_INPUT_PROPERTIES.GENERAL,
    ...COMMON_INPUT_PROPERTIES.LAYOUT,
  ],
  CHOICE_BY_URL: [...COMMON_INPUT_PROPERTIES.CHOICES_FROM_WEB_SERVICE],
  // OUTPUT: ['output', 'testValue'],
};

export const propertyHideMapping: Record<string, string[]> = {
  [PROPERTY_TYPES.SURVEY]: INCLUDED_SURVEY_PROPERTIES,
  [PROPERTY_TYPES.PAGE]: INCLUDED_PAGE_PROPERTIES,
  [PROPERTY_TYPES.RADIO_GROUP]: INPUT_PROPERTIES.RADIO_GROUP,
  [PROPERTY_TYPES.CHECKBOX]: INPUT_PROPERTIES.CHECKBOX,
  [PROPERTY_TYPES.RATTING]: INPUT_PROPERTIES.RATTING,
  [PROPERTY_TYPES.DROPDOWN]: INPUT_PROPERTIES.DROPDOWN,
  [PROPERTY_TYPES.TAG_BOX]: INPUT_PROPERTIES.MULTI_SELECT_DROP_DOWN,
  [PROPERTY_TYPES.BOOLEAN]: INPUT_PROPERTIES.YES_NO_BOOLEAN,
  [PROPERTY_TYPES.FILE]: INPUT_PROPERTIES.FILE_UPLOAD,
  [PROPERTY_TYPES.IMAGE_PICKER]: INPUT_PROPERTIES.IMAGE_PICKER,
  [PROPERTY_TYPES.RANKING]: INPUT_PROPERTIES.RANKING,
  [PROPERTY_TYPES.TEXT]: INPUT_PROPERTIES.SINGLE_LINE_TEXT,
  [PROPERTY_TYPES.COMMENT]: INPUT_PROPERTIES.LONG_TEXT,
  [PROPERTY_TYPES.MULTIPLE_TEXT]: INPUT_PROPERTIES.MULTIPLE_TEXT_BOX,
  [PROPERTY_TYPES.PANEL]: INPUT_PROPERTIES.PANEL,
  [PROPERTY_TYPES.PANEL_DYNAMIC]: INPUT_PROPERTIES.PANEL_DYNAMIC,
  [PROPERTY_TYPES.MATRIX]: INPUT_PROPERTIES.SINGLE_SELECT_MATRIX,
  [PROPERTY_TYPES.MATRIX_DROPDOWN]: INPUT_PROPERTIES.MULTI_SELECT_MATRIX,
  [PROPERTY_TYPES.MATRIX_DYNAMIC]: INPUT_PROPERTIES.DYNAMIC_MATRIX,
  [PROPERTY_TYPES.HTML]: INPUT_PROPERTIES.HTML,
  [PROPERTY_TYPES.IMAGE]: INPUT_PROPERTIES.IMAGE,
  [PROPERTY_TYPES.CHOICE_BY_URL]: INPUT_PROPERTIES.CHOICE_BY_URL,
  // [PROPERTY_TYPES.SPARK_OUTPUT_CLASS]: INPUT_PROPERTIES.OUTPUT,
};

// Default survey properties
export const DEFAULT_VALUE_MAP: Partial<SurveyModel> = {
  questionTitlePattern: 'numRequireTitle',
  showProgressBar: 'off',
  progressBarShowPageNumbers: true,
  completeText: 'Run Spark',
  // focusFirstQuestionAutomatic: true,
  optionsCaption: 'Please Select',
  showQuestionNumbers: 'off',
};
